import { render, staticRenderFns } from "./NewFeeModal.vue?vue&type=template&id=808b5624&scoped=true&"
import script from "./NewFeeModal.vue?vue&type=script&lang=js&"
export * from "./NewFeeModal.vue?vue&type=script&lang=js&"
import style0 from "./NewFeeModal.vue?vue&type=style&index=0&id=808b5624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808b5624",
  null
  
)

component.options.__file = "NewFeeModal.vue"
export default component.exports